import { render, staticRenderFns } from "./FeaturesPage.vue?vue&type=template&id=35c97de4&scoped=true"
import script from "./FeaturesPage.vue?vue&type=script&lang=js"
export * from "./FeaturesPage.vue?vue&type=script&lang=js"
import style0 from "./FeaturesPage.vue?vue&type=style&index=0&id=35c97de4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c97de4",
  null
  
)

export default component.exports